import { render, staticRenderFns } from "./CourseHTML.vue?vue&type=template&id=f80a815c&scoped=true&"
import script from "./CourseHTML.vue?vue&type=script&lang=js&"
export * from "./CourseHTML.vue?vue&type=script&lang=js&"
import style0 from "./CourseHTML.vue?vue&type=style&index=0&id=f80a815c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80a815c",
  null
  
)

component.options.__file = "CourseHTML.vue"
export default component.exports